import CreateEditNewScan from "./CreateEditNewScan"

const CreateEditNewScanContainer = (props: any) => {
    const { handleNameChange, handleDatesChange, values, isScanSavedFlag } = props

    return(
        <CreateEditNewScan 
            handleNameChange={handleNameChange}
            handleDatesChange={handleDatesChange}
            values={values}
            isScanSavedFlag={isScanSavedFlag}
        />
    )
}

export default CreateEditNewScanContainer